import(/* webpackMode: "eager" */ "/home/runner/a1/_work/transcripta-landing/transcripta-landing/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ScriptarioSeoLanding"] */ "/home/runner/a1/_work/transcripta-landing/transcripta-landing/src/components/landing/ScriptarioSeoLanding.tsx");
